import { useState } from "react"

import airbrake from "src/airbrake-notifier"

import { gql, useClient, useMutation } from "hooks/urql"

import { ChimeJoinInfo } from "./types"

const useJoinAudioRoom = (audioRoomId: string) => {
  const client = useClient()
  const [mutationState, runMutation]: any[] = useMutation(
    joinAudioRoomMutation,
    client
  )
  const [chimeJoinInfo, setChimeJoinInfo] = useState<ChimeJoinInfo | null>(null)
  const [controlsUnlockedUserIds, setControlsUnlockedUserIds] = useState<
    string[]
  >([])
  const [joinError, setJoinError] = useState<string>()

  const reportJoinError = (airbrakeMessage: string, error?: unknown) => {
    airbrake.notify({
      message: airbrakeMessage,
      error,
      params: {
        name: "AudioRoom/useJoinAudioRoom.ts",
        roomId: audioRoomId,
        currentUserId: chimeJoinInfo?.attendee?.externalUserId,
      },
    })
  }

  const onJoin = () => {
    runMutation({ audioRoomId })
      .then(result => {
        const { failures, joinInfo, audioRoom } = result.data.joinAudioRoom

        if (failures.length > 0) {
          setJoinError(
            "Sorry, unable to join classroom. Please refresh to try again"
          )
          reportJoinError(
            `User unable to join audio room: ${failures[0].message}`
          )
        } else {
          setChimeJoinInfo(joinInfo)
          setControlsUnlockedUserIds(audioRoom.controlsUnlockedUserIds)
        }
      })
      .catch(error => {
        setJoinError(
          "Sorry, unable to join classroom. Please refresh to try again"
        )
        reportJoinError("User unable to join audio room", error)
      })
  }

  return {
    chimeJoinInfo,
    controlsUnlockedUserIds,
    onJoin,
    isJoining: mutationState.fetching,
    joinError,
  }
}

const joinAudioRoomMutation = gql`
  mutation JoinAudioRoom($audioRoomId: ID!) {
    joinAudioRoom(audioRoomId: $audioRoomId) {
      joinInfo {
        attendee {
          attendeeId
          externalUserId
          joinToken
        }
        meeting
      }
      audioRoom {
        controlsUnlockedUserIds
      }
      failures {
        message
      }
    }
  }
`

export default useJoinAudioRoom
